import React from 'react';
import { cn } from '../../lib/utils';

interface PageTitleSectionProps {
  children?: React.ReactNode;
  title: string;
  className?: string;
}

function PageTitleSection({
  children,
  title,
  className
}: Readonly<PageTitleSectionProps>): React.ReactElement {
  return (
    <section className={cn('w-full mb-6', className)}>
      <div className='flex flex-col gap-2 md:flex-row md:justify-between md:items-start md:gap-0 md:min-h-[40px]'>
        <h1 className='text-3xl font-bold m-0 md:leading-tight'>{title}</h1>
        {children && <div className='md:flex md:items-center'>{children}</div>}
      </div>
    </section>
  );
}

export default PageTitleSection;
